<template>
    <div class="Parallax"><swiper
        :style="{
        '--swiper-pagination-color': '#513890',
        }"
        :speed="1200"
        :parallax="true"
        :pagination="{
            clickable: true,
        }"
        :navigation="{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
            hideOnClick: true
        }"
        :modules="modules"
        :direction="'vertical'"
        class="swiper swiper_01">
        <div
            slot="container-start"
            class="parallax-bg"
            data-swiper-parallax="-23%">
        </div>
        <!-- :style="{
                'background-image':
                'url(https://swiperjs.com/demos/images/nature-1.jpg)',
            }" -->
        <swiper-slide>
            <h1>
                <span class="title" data-swiper-parallax="-200">ABOUT US</span>
                <span class="subtitle" data-swiper-parallax="-300">关于我们</span>
            </h1>
            <div class="text" data-swiper-parallax="-100">
                <p>
                    &emsp;&emsp;圣七教育致力于为中小学提供前沿的<b style="font-size: larger">STEM教育解决方案</b>，帮助学生在创新实践中构建未来核心竞争力。我们专注于将国际优质教育资源本地化，打造系统化的课程与竞赛支持服务，推动跨学科融合式学习在中国校园落地生根。<br/><br/>
                    &emsp;&emsp;我们提供涵盖基础建模、机械结构、城市规划、人工智能、可持续设计等方向的系统课程，支持学校建设创新实验室、科技社团、项目式学习课程和特色选修课，帮助学生夯实科学与工程基础，激发实践创造力。<br/><br/>
                    &emsp;&emsp;圣七教育是多个国际知名赛事的合作方与认证机构，为学生提供从入门到精英级别的竞赛支持，服务对象覆盖小学高年级至高中阶段，帮助学生在<b style="font-size: larger">“WRO创意赛”</b>、<b style="font-size: larger">“F1在学校”</b>、<b style="font-size: larger">“未来工程师”</b>、<b style="font-size: larger">“未来之城”</b>等赛事中取得优异成绩。<br/><br/>
                </p>
            </div>
            <swiper_03 data-swiper-parallax="-300"></swiper_03>
        </swiper-slide>
        <swiper-slide>
            <h1>
                <span class="title" data-swiper-parallax="-200">PRODUCTS & SERVICE</span>
                <span class="subtitle" data-swiper-parallax="-300">我们的业务</span>
            </h1>
            <div class="text" data-swiper-parallax="-100"></div>
            <step data-swiper-parallax="-100"></step>
        </swiper-slide>
        <swiper-slide>
            <h1>
                <span class="title" data-swiper-parallax="-200">WHY US?</span>
                <span class="subtitle" data-swiper-parallax="-300">为什么选择我们</span>
            </h1>
            <ParaCard data-swiper-parallax="-100"></ParaCard>
        </swiper-slide>
    </swiper>
    <div class="swiper-button-prev"><h1><el-icon class="custom"><Upload /></el-icon></h1></div>
    <div class="swiper-button-next"><h1><el-icon class="custom"><Download /></el-icon></h1></div></div>
</template>

<script>

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

// import 'swiper/css/navigation';
import 'swiper/css/pagination';

import swiper_03 from '@/components/FadeVue.vue';
import step from '@/components/StepVue.vue';
import ParaCard from './ParaCard.vue';

// import required modules
import { Navigation, Pagination, Parallax } from 'swiper/modules';
// Navigation,
export default {
    components: {
        Swiper,
        SwiperSlide,
        swiper_03,
        step,
        ParaCard
    },
    setup() {
        return {
            modules: [ Navigation, Parallax, Pagination, ],
        };
    },
};
</script>

<style scoped>
.swiper {
    width: 100%;
    height: 48vw;
    background: #fff;
}

.swiper-slide {
    color: #513890;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 3vw 6vw;
}

.swiper-button-next {
    left: 50%;
    top: 98vw;
    color: transparent
}

.swiper-button-prev {
    left: 50%;
    top: 56vw;
    color: transparent
}

.custom {
    font-size: calc(100vw * 32 / 1920);
    color: #513890
}

.parallax-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 130%;
    -webkit-background-size: cover;
    background-size: cover;
    background-position: center;
    /* background-image: url('../assets/images/Parallax/back1.png'); */
}

.swiper-slide .title {
    font-family: 'Regular';
    font-size: 3.5vmin;
    margin-top: 3vw;
    display: block;
}

.swiper-slide .subtitle {
    font-family: 'FangYuan';
    font-size: 3vmin;
    font-weight: normal;
    letter-spacing: 0.3em;
    display: block;
}

.swiper-slide .text {
    font-family: 'FangYuan';
    font-size: calc(100vw * 20 / 1920);
    font-weight: normal;
    letter-spacing: 0.16em;
    line-height: 2em;
    margin-top: 2vw;
    max-width: 52vw;
    text-align: left;
    padding: 1em;

}

.swiper-slide .image {
    position: absolute;
    top: 20vh;
    right: -6vh;
}

.swiper_03 {
    position: absolute;
    height: max-content;
    width: 28vw;
    right: 6vw;
    top: 14vw;
}

</style>